<script>
  import axios from 'axios'
  import titreDefault from '@/components/shared/presentation/titre-default.vue'

  export default {
    name: 'BookRating',
    props: {
      id: {
        type: String,
      },
      contexteId: {
        required: true,
      },
    },
    data () {
      return {
        hasBeenRated: false,
        rating: 'Robert s\'est trompé',
        wantToRate: false,
        livre: false,
      }
    },
    components: {
      titreDefault,
    },
    methods: {
      async rateBook (ean13, rating = true) {
        if (this.hasBeenRated === true) return
        this.$once('animation-finish', () => {
          this.$nextTick(() => {
            this.hasBeenRated = true
          })
        })
        this.wantToRate = false
        this.rating = rating
        // await axios.evaluer(ean13, { params: { liaison: rating }, cacheResponse: false })
        await axios.post(`/api/v2/ia/suggestions/${ean13}/evaluer`, undefined, { params: { liaison: rating } })
      },
      resetEditState () {
        setTimeout(() => {
          this.wantToRate = false
        }, 1000)
      },
      wantsToRate (livre) {
        this.wantToRate = true
        this.livre = livre
      },
    },
  }
</script>

<template lang="pug">

div.book-rating(:class="{'-rated': hasBeenRated}", @mouseleave="resetEditState", @click="$emit('show-desc', id)")
  transition(name="book-rating-panel")
    div.panelmask(v-show="hasBeenRated", :style="{ backgroundColor: rating ? 'rgba(255,176,45,.6)' : 'rgba(221,12,232,.6)'}")
      span.is-pre-line {{rating ? 'Robert \na raison' : 'Robert \ns\'est trompé'}}
  transition(name="fade", @after-leave="$emit('animation-finish')", mode="out-in")
    div.inheritheight(v-if="!wantToRate", key="1")
      titre-default(v-if="id", :id="id")
        template(scope="{ livre }")
          button.evaluer(type="button", class="button", @click.stop="wantsToRate(livre)") Évaluer
    div.inheritheight.ratingbtns(v-else, key="2")
      button.btnrating(type="button", class="button", @click.stop="rateBook(livre.ean13, true)") Robert <br>a raison
      hr(class="separator")
      button.btnrating(type="button", class="button", @click.stop="rateBook(livre.ean13, false)") Robert <br>s'est trompé
</template>

<style lang="postcss" scoped>

  .book-rating {
    position: relative;
    overflow: hidden;
    z-index: 1;

    &.-rated {

    }

    & .btnrating {
      flex: 1 0 50%;
      border: none;
      font-weight: bold;
      font-size: rem(24);
      background: none;
    }
    & .ratingbtns {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 10% 10px;
    }
    & .inheritheight {
      height: inherit;
    }
    & .panelmask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,.85);
      box-shadow: inset 0 0 50px rgba(0,0,0,.7);
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: rem(24);
      font-weight: bold;
      z-index: 10;
    }
  }

</style>
<style lang="postcss">

  .book-rating {
    & .evaluer {
      flex: 0 0 auto;
    }
  }
  .book-rating-panel-enter-to {
    transform: translateY(0);
  }
  .book-rating-panel-enter,  .book-rating-panel-leave-to {
    transform: translateY(100%);
  }
  .book-rating-panel-enter-active,  .book-rating-panel-leave-active {
    transition: transform .3s ease-in-out;
  }

</style>



// WEBPACK FOOTER //
// book-rating.vue?920ea22a